module.exports = __webpack_public_path__ + "static/media/lgmlogo.80c2559b.jpg";